import { c as _c } from "react/compiler-runtime";
import type { OnboardingDataEntry } from '@onefootprint/request-types/dashboard';
import { CodeBlock } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { OUTPUT_DATA_NAMESPACE } from '../output-node.constants';
type OutputTraceResultProps = {
  onboardingData: OnboardingDataEntry[];
};
const NAMESPACE_PREFIX = `${OUTPUT_DATA_NAMESPACE}.`;
export const OutputTraceResult = t0 => {
  const $ = _c(22);
  const {
    onboardingData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "outputNode.result"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[1] !== onboardingData || $[2] !== t) {
    const outputs = Object.fromEntries(onboardingData.map(_temp));
    T0 = CodeBlock;
    t2 = "json";
    if ($[10] !== t) {
      t3 = t(_temp2);
      $[10] = t;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    if ($[12] !== t) {
      t4 = t(_temp3);
      $[12] = t;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    t5 = "secondary";
    t6 = "240px";
    t7 = JSON.stringify(outputs, null, 2);
    $[1] = onboardingData;
    $[2] = t;
    $[3] = T0;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    T0 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[14] !== T0 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <T0 language={t2} title={t3} ariaLabel={t4} backgroundColor={t5} maxHeight={t6}>{t7}</T0>;
    $[14] = T0;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
function _temp(t0) {
  const {
    key,
    value
  } = t0;
  return [key.replace(NAMESPACE_PREFIX, ""), value];
}
function _temp2($) {
  return $.title;
}
function _temp3($_0) {
  return $_0.copy;
}